import { gridSize } from '@atlaskit/theme';
import styled from '@emotion/styled';

type ImageProps = {
    maxWidth: number;
    maxHeight: number;
};

const Image = styled.img<ImageProps>`
    max-width: ${({ maxWidth }) => maxWidth}px;
    max-height: ${({ maxHeight }) => maxHeight}px;
    margin: 0 auto ${gridSize() * 3}px;
    display: block;
`;

export default Image;
